<template>
  <template v-for="tick in timelineTicks(d, timezone, settingsStore.hideEarlyMorning)" :key="tick.time">
    <div class="absolute inset-y-0" :style="`left:${tick.xPct}%;`">
      <div class="absolute top-0 border-l left-0" :style="`height:${tick.major ? '40%' : '20%'};`"></div>
      <div v-show="tick.major" class="absolute top-[40%] text-sm text-secondary -translate-x-1/2 whitespace-nowrap">{{ tick.label }}</div>
    </div>
  </template>
</template>

<script setup>
import { useSettingsStore } from '../stores/settings.js';
const settingsStore = useSettingsStore();
import { timelineTicks } from '../utils/dataTransforms.js';

const props = defineProps({
  d: {
    type: Object, // Assuming 'd' is a Date object or similar
    required: true,
  },
  timezone: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
/* Add any specific styles for the timeline component here if needed */
</style>